// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "" + (chunkId === 60868 ? "auth-suite-sdk" : chunkId) + "-" + {"9497":"e57ffd75264095dac444","14900":"d7e073ce075431324dcc","60868":"9e49fca8c5126ce6ea43","72130":"ed20f7beadadba54ee84","75667":"3d6749635bd1dd8e5868","78179":"674a6a7f588d280af91e","88429":"324c339dc00434f0c467"}[chunkId] + ".min.js";
};